<template>
    <ModalFormCard class="modal-default" :action='"/admin/balance/" + subscription.company_id'>
        <template #title>Update account balance</template>

        <template #default="{ saving, errors }">
            <p class='text-15 font-semibold'>Update account balance for {{ subscription.company.name }}</p>
            <p class='text-14 text-grey-900 mt-2'>
                You can use this to add or remove money from the customers stripe account.
                Doing this will effect the next invoice that is generated.
                If the balance is a negative this value will be added to the next invoice.
                If the balance is posative this value will be removed from the next invoice.
            </p>

            <Select class='mt-4' name='reason'
                v-model:value='value.reason'
                placeholder='Reason'
                label='Reason for ad spend change' 
                :options="[
                    { value: 'Poor performance' },
                    { value: 'Other' },
                ]" 
            />

            <Textarea name='reason_other' v-model:value='value.reason_other' 
                label='Other reason' v-if='value.reason == "Other"' 
                class='mt-4'
            /> 

            <Input name='amount' class='mt-4'
                v-model:value='value.amount' label='Balance to add' />

            <InputCheckbox class='mt-4' name="accepted" value="1">
                <p class="text-14 text-grey-900 pl-2">
                    Current balance is {{ $help.dp(parseFloat(balance)) }}, 
                    new balance will be {{ $help.dp(newBalance) }}.
                    <template v-if='parseFloat(newBalance) > 0'>
                        The next invoice will have a discount of {{ $help.dp(newBalance) }}
                    </template> 
                    <template v-if='parseFloat(newBalance) < 0'>
                        The next invoice will have {{ $help.dp(newBalance * -1) }} added to it.
                    </template> 
                    Are you sure you want to do this?</p>
            </InputCheckbox>

            <div class="modal-buttons pt-6">
                <ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					Update balance
				</ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'

    export default {
        mixins: [Modal],

        data() {
            return {
                balance: 0,
                value: {
                    reason: null,
                    reason_other: '',
                    amount: 0
                }
            }
        },

        created() {
            this.getBalance()
        },

        methods: {
            getBalance() {
                this.$axios.get("/admin/balance/" + this.subscription.company_id)
                    .then(res => {
                        this.balance = res.balance;
                    });
            }
        },  

        computed: {
            subscription() {
                return this.editingModel
            },

            newBalance() {
                return parseFloat(this.balance) + parseFloat(this.value.amount)
            }
        }
    }
</script>